import { render, staticRenderFns } from "./ForwardDepartment.vue?vue&type=template&id=79330299&scoped=true"
import script from "./ForwardDepartment.vue?vue&type=script&lang=js"
export * from "./ForwardDepartment.vue?vue&type=script&lang=js"
import style0 from "./ForwardDepartment.vue?vue&type=style&index=0&id=79330299&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79330299",
  null
  
)

export default component.exports